export const setNotecardPreview = (bounds) => ({
    type: 'SET_NOTECARD_PREVIEW',
    bounds
})

export const addNotecard = (x, y, w, h) => ({
    type: 'ADD_NOTECARD',
    x, y, w, h
})

export default {
    setNotecardPreview,
    addNotecard
}